import React from 'react';
import IconBase, { iconPropTypes } from '../IconBase';

export default function OutletIcon(props) {
	return (
		<IconBase type="outlet" {...props}>
			<path d="M9 7C8.44771 7 8 7.44772 8 8V11C8 11.5523 8.44771 12 9 12C9.55228 12 10 11.5523 10 11V8C10 7.44772 9.55228 7 9 7Z" />
			<path d="M14 8C14 7.44772 14.4477 7 15 7C15.5523 7 16 7.44772 16 8V11C16 11.5523 15.5523 12 15 12C14.4477 12 14 11.5523 14 11V8Z" />
			<path d="M12 14C10.8954 14 10 14.8954 10 16V18H14V16C14 14.8954 13.1046 14 12 14Z" />
			<path d="M18.001 4H5.99903C3.57069 5.82446 2 8.7288 2 12C2 15.2712 3.57069 18.1755 5.99903 20H18.001C20.4293 18.1755 22 15.2712 22 12C22 8.7288 20.4293 5.82446 18.001 4ZM21 12C21 14.8265 19.698 17.3486 17.6574 19H6.3426C4.30195 17.3486 3 14.8265 3 12C3 9.17353 4.30195 6.65142 6.3426 5H17.6574C19.698 6.65142 21 9.17353 21 12Z" />
		</IconBase>
	);
}
OutletIcon.propTypes = iconPropTypes;
